import React from "react";
import ResultHeader from "./ResultHeader";
import ResultBody from "./ResultBody";
import ResultFooter from "./ResultFooter";

export default class Result extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div aria-label='Resultat Website Scanner'>
                <ResultHeader
                    apiBase={this.props.apiBase}
                    url={this.props.url}
                    result={this.props.result}
                    premium={this.props.premium}
                />

                <ResultBody
                    url={this.props.url}
                    result={this.props.result}
                />

                {(!this.props.premium) && (
                    <ResultFooter
                        url={this.props.url}
                    />
                )}
            </div>
        )
    }
}
